<template>
  <section class="updatepwd-box">
    <el-dialog
      :title="force?'首次登录请修改密码':'忘记密码'"
      :visible.sync="force?true:myVisible"
      width="500px"
      :close-on-click-modal="!force"
      :close-on-press-escape="!force"
      :show-close="!force"
      :class="force?'force':''"
      >
      <el-form :model="handleForm" status-icon :rules="rules" ref="handleForm" label-width="100px" class="demo-handleForm">
        <el-form-item label="手机号码" prop="phoneNo">
          <el-input :disabled="!!userInfo.phone" type="text" placeholder="请输入手机号码" v-model="handleForm.phoneNo" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <el-input type="text" placeholder="请输入验证码" v-model="handleForm.smsCode" maxlength="6">
            <el-button slot="append" type="primary" class="msg-btn" :class="countDown.startCount && 'sended'" @click="getSmsCode">{{countDown.startCount ? countDown.count+'s后重试' :'获取验证码'}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input type="password" placeholder="请输入密码" v-model="handleForm.pass" maxlength="20"></el-input>
          <div class="tips">密码需包含数字、大小写字母、长度在6-20位之间</div>
        </el-form-item>
        <el-form-item label="确认密码"  prop="checkPass">
          <el-input type="password" placeholder="请再次输入密码" v-model="handleForm.checkPass" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
          <el-button @click="handleClose">{{force?'退出':'取消'}}</el-button>
          <el-button type="primary" @click="handleLogin('handleForm')" :loading="logining">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
// import storage from '@/utils/storage'
// import RsaKey from '@/utils/rsa'
export default {
  name: 'updatePwd',
  props: {
    userInfo: {
      required: false,
      type: Object,
      default: () => { return {} }
    },
    force: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'myVisible': function (value) {
      if (!value) {
        this.$emit('close')
      }
    }
  },
  data () {
    var validatePhoneNo = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!(/^1[123456789]\d{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      var regex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,20}')

      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!regex.test(value)) {
        callback(new Error('密码格式错误,请重新输入'))
      } else {
        if (this.handleForm.checkPass !== '') {
          this.$refs.handleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.handleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      myVisible: true,
      logining: false,
      handleForm: {
        phoneNo: '',
        smsId: null,
        pass: '',
        checkPass: ''
      },
      countDown: {
        startCount: false,
        timer: {},
        defaultCount: 60,
        count: 60
      },
      rules: {
        phoneNo: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
        smsCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        pass: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.handleForm.phoneNo = this.userInfo.phone
  },
  methods: {
    getSmsCode () {
      this.$refs.handleForm.validateField('phoneNo', value => {
        if (!value) {
          const params = {
            phoneNo: this.handleForm.phoneNo
            // smsType: 8
          }
          this.api.commonService.getSmsCode(params).then(res => {
            if (res.code === '644') {
              this.$message.error('获取验证码太频繁，请稍后重试')
            } else if (res.errorMessage) {
              this.$message.error('获取验证码失败，请稍后重试')
            } else {
              this.handleForm.smsId = res.body.smsId
              this.handleCountDown()
            }
          })
        }
      })
    },
    handleCountDown () {
      this.countDown.startCount = true
      this.countDown.timer = setInterval(() => {
        if (this.countDown.count === 0) {
          clearInterval(this.countDown.timer)
          this.countDown.startCount = false
          this.countDown.count = this.countDown.defaultCount
        } else {
          this.countDown.count--
        }
      }, 1000)
    },
    handleLogin () {
      if (!this.handleForm.smsId) {
        this.$message.error('请先获取验证码')
        return
      }
      this.$refs.handleForm.validate((valid) => {
        if (valid) {
          this.logining = true
          const password = this.handleForm.pass.trim()
          this.getUserinfo(password)
        }
      })
    },
    handleClose () {
      if (this.force) {
        this.utils.logout()
      } else {
        this.myVisible = false
      }
    },
    getUserinfo (encryptedpassword) { // 获取用户信息
      let loginParams = {
        mobileNo: this.handleForm.phoneNo,
        username: this.userInfo.username ? this.userInfo.username.trim() : undefined,
        pazzword: encryptedpassword,
        smsId: this.handleForm.smsId,
        smsCode: this.handleForm.smsCode
      }
      // 这里只做登录状态验证
      this.api.commonService.updateUmUserPassword(loginParams).then(data => {
        if (data.code === '200' || data.code === '610') {
          this.$message.success('修改成功，请重新登录')
          this.myVisible = false
        } else {
          this.$message.error(data.errorMessage)
          this.logining = false
        }
      })
    }
  }
}
</script>
<style lang="less">
  .updatepwd-box{
    .tips{
      color: #999;
      line-height: initial;
    }
  }
  .force{
      .el-dialog__header{
        text-align: center;
        .el-dialog__title{
          font-size: 24px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/UpdatePwd.vue